export default __webpack_public_path__ + "static/media/form-side-image.72d28edd.jpg";